import { k as ensure_array_like, c as attr_class, b as attr, e as escape_html, n as maybe_selected, p as pop, a as push, m as stringify } from "./index2.js";
function ProductFilterSidebar($$payload, $$props) {
  push();
  const {
    categories,
    selectedCategories,
    selectedYear,
    years,
    isMobileFiltersOpen,
    onCategoryToggle,
    onYearChange,
    onClearFilters,
    onToggleMobileFilters
  } = $$props;
  const each_array = ensure_array_like(categories);
  const each_array_1 = ensure_array_like(years);
  if (isMobileFiltersOpen) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<div class="fixed inset-0 z-40 bg-black/10 backdrop-blur-[1px] lg:hidden" role="button" tabindex="0" aria-label="Close filters"></div>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--> <aside${attr_class(`fixed top-0 left-0 z-50 h-full w-80 bg-white shadow-xl transition-transform duration-150 ease-in-out lg:sticky lg:top-4 lg:z-0 lg:h-fit lg:max-h-[calc(100vh-2rem)] lg:w-64 lg:translate-x-0 lg:shadow-none ${stringify(isMobileFiltersOpen ? "translate-x-0" : "-translate-x-full")}`)}><div class="h-full overflow-y-auto p-6"><div class="mb-4 flex items-center justify-between md:hidden"><h2 class="text-lg font-semibold">Filters</h2> <button class="p-1" aria-label="Close filters"><i class="bi bi-x-lg"></i></button></div> <div class="mb-6"><div class="mb-4 flex items-center justify-between"><h3 class="text-lg font-semibold">Categories</h3> <button aria-label="Collapse categories"><i class="bi bi-chevron-up text-sm"></i></button></div> <div class="space-y-3"><!--[-->`);
  for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
    let category = each_array[$$index];
    $$payload.out.push(`<label class="flex cursor-pointer items-center justify-between"><div class="flex items-center"><input type="checkbox" class="mr-3 h-4 w-4 rounded"${attr("checked", selectedCategories.includes(category.id), true)}/> <span class="text-sm text-gray-700">${escape_html(category.name)}</span></div> `);
    if (selectedCategories.length === 0 || selectedCategories.includes(category.id)) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<span class="text-xs text-gray-500">(${escape_html(category.count)})</span>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--></label>`);
  }
  $$payload.out.push(`<!--]--></div></div> <div class="mb-6"><h3 class="mb-4 text-lg font-semibold">Publication Year</h3> ${escape_html(selectedYear)} <select class="focus:border-primary focus:ring-primary/30 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm focus:ring-5 focus:outline-hidden">`);
  $$payload.select_value = selectedYear;
  $$payload.out.push(`<option value="all"${maybe_selected($$payload, "all")}>All Years</option><!--[-->`);
  for (let $$index_1 = 0, $$length = each_array_1.length; $$index_1 < $$length; $$index_1++) {
    let year = each_array_1[$$index_1];
    $$payload.out.push(`<option${attr("value", year)}${maybe_selected($$payload, year)}>${escape_html(year)}</option>`);
  }
  $$payload.out.push(`<!--]-->`);
  $$payload.select_value = void 0;
  $$payload.out.push(`</select></div> `);
  if (selectedCategories.length > 0 || selectedYear !== "all") {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<button class="w-full rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-700 hover:bg-gray-200">Clear All Filters</button>`);
  } else {
    $$payload.out.push("<!--[!-->");
  }
  $$payload.out.push(`<!--]--></div></aside>`);
  pop();
}
export {
  ProductFilterSidebar as P
};
